import { useLayoutEffect, useCallback, useState } from "react"
import dlv from "dlv"
import professions from "./professions"
// returns hair when only hair, or make up, OR hair&make up, so skips the second and third, when first matches
export const getProfessions = tags =>
  professions.filter((profession, index) =>
    tags.find(
      tag =>
        tag.name === profession &&
        (index === 0 ||
          index > 2 ||
          !tags.find(tag => tag.name === professions[0]))
    )
  )

export const get = dlv
/* (obj, key) => {
  return key.split(".").reduce((o, x) => {
    return typeof o === "undefined" || o === null ? o : o[x]
  }, obj)
} */

export const getAlbumKeyValue = (album, key) => {
  return get(
    album.keyValues.find(keyValue => keyValue.key.name === key),
    "value"
  )
}

export const useRect = ref => {
  const [rect, setRect] = useState(getRect(ref ? ref.current : null))

  const handleResize = useCallback(() => {
    if (!ref.current) {
      return
    }

    // Update client rect
    setRect(getRect(ref.current))
  }, [ref])

  useLayoutEffect(() => {
    const element = ref.current
    if (!element) {
      return
    }

    handleResize()

    if (typeof ResizeObserver === "function") {
      let resizeObserver = new ResizeObserver(() => handleResize())
      resizeObserver.observe(element)

      return () => {
        if (!resizeObserver) {
          return
        }

        resizeObserver.disconnect()
        resizeObserver = null
      }
    } else {
      // Browser support, remove freely
      window.addEventListener("resize", handleResize)

      return () => {
        window.removeEventListener("resize", handleResize)
      }
    }
  }, [ref.current])

  return rect
}

function getRect(element) {
  if (!element) {
    return {
      bottom: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0,
      width: 0
    }
  }

  return element.getBoundingClientRect()
}
